/**
 * canvas-engine/presets/presetData/customPresets.js
 *
 * TRANSCRIBED Custom_Code_Section (Custom HTML / Custom CSS) starter VALUES.
 *
 * ZERO-REUSE CONSTRAINT (Task 3.1): imports NOTHING. The starter HTML/CSS
 * snippets and frame style are transcribed from the Default_Source `customHtml`
 * branches of each domain's `create*Section` factory as plain DATA.
 * No React, no rendering, no side effects.
 *
 * The custom adapter (Task 3.3 `custom.js`) maps:
 *   - Custom HTML → an `html` Canvas_Element carrying `content.html`
 *   - Custom CSS  → `content.css` style data scoped to the section (Req 4.3)
 *
 * Requirements: 3.6, 3.7, 5.1, 5.7
 */

const style = (overrides = {}) => ({
  background: '#ffffff',
  textColor: '#111827',
  padding: '40px 24px',
  ...overrides,
});

/**
 * CUSTOM_PRESETS — custom HTML/CSS starter descriptors.
 *  - `customHtml`: a single `html` element seeded with safe starter markup +
 *    scoped CSS.
 *  - `customCss` : section-level CSS data only (no markup), for the CSS section.
 */
export const CUSTOM_PRESETS = {
  customHtml: {
    sectionType: 'customHtml',
    label: 'Custom HTML/CSS',
    domain: 'generic',
    style: style(),
    layout: { align: 'left', width: 'contained' },
    content: {
      title: 'Custom section',
      // Maps to an `html` Canvas_Element's content.html + content.css.
      html: '<div class="custom-section"><h2>Custom content</h2><p>Edit this HTML safely.</p></div>',
      css: '.custom-section { max-width: 960px; margin: 0 auto; }',
    },
  },

  customCss: {
    sectionType: 'customCss',
    label: 'Custom CSS',
    domain: 'generic',
    style: style({ padding: '0' }),
    layout: { align: 'left', width: 'contained' },
    content: {
      title: 'Custom CSS',
      // Section-scoped CSS data only (Req 4.3).
      css: '.custom-section { /* add scoped styles here */ }',
    },
  },
};

/**
 * Per-domain custom HTML/CSS starter snippets (transcribed verbatim from the
 * Default_Source `customHtml` branches). The custom adapter selects the snippet
 * matching the active domain so a freshly inserted custom section matches the
 * domain's default starter copy.
 */
export const customStartersByDomain = {
  generic: {
    html: '<div class="custom-section"><h2>Custom content</h2><p>Edit this HTML safely.</p></div>',
    css: '.custom-section { max-width: 960px; margin: 0 auto; }',
    style: style(),
  },
  education: {
    html: '<div class="custom-section"><h2>Custom content</h2><p>Edit this HTML safely.</p></div>',
    css: '.custom-section { max-width: 960px; margin: 0 auto; }',
    style: style(),
  },
  waas: {
    html: '<div class="waas-custom"><h2>Add your IT section</h2><p>Edit this safe HTML and scoped CSS with your company service content.</p></div>',
    css: '.waas-custom { max-width: 920px; margin: 0 auto; text-align: center; }',
    style: style({ background: '#f8fafc', padding: '56px 24px' }),
  },
  flexOffice: {
    html: '<div class="flex-custom"><h2>Custom workspace section</h2><p>Edit this HTML safely for your Flex Office page.</p></div>',
    css: '.flex-custom { max-width: 960px; margin: 0 auto; text-align: center; }',
    style: style({ padding: '80px 24px' }),
  },
  retail: {
    html: '<div class="retail-custom"><h2>Custom retail content</h2><p>Edit this HTML safely for your storefront.</p></div>',
    css: '.retail-custom { max-width: 960px; margin: 0 auto; text-align: center; }',
    style: style({ padding: '72px 24px' }),
  },
};

export default CUSTOM_PRESETS;
